import popcornImg from '../assets/popcorn.png';
import pretzelsImg from '../assets/pretzels.png';
import appleSlicesImg from '../assets/appleSlices.png';
import cheesePizzaImg from '../assets/cheesePizza.png';
import chocolateBarImg from '../assets/chocolateBar.png';
import crackersnCheeseImg from '../assets/crackersnCheese.png';
import darkChocolateImg from '../assets/darkChocolate.png';
import iceCreamConeImg from '../assets/iceCreamCone.png';
import nachoChipsImg from '../assets/nachoChips.png';
import pbnjSandwichImg from '../assets/pbnjSandwich.png';
import popRocksImg from '../assets/popRocks.png';
import trailMixImg from '../assets/trailMix.png';

export const HOROSCOPE1 = [
  {
    zodiac: '♈︎ Aries',
    image: nachoChipsImg,
    title: 'Nacho Chips',
    description:
        'Retrogrades slow you down—grab a crunch that keeps pace.',
  },
  {
    zodiac: '♉︎ Taurus',
    image: chocolateBarImg,
    title: 'Chocolate Bar',
    description:
        'Venus in Virgo says: savor something sweet, simple, and grounding.',
  },
  {
    zodiac: '♊︎ Gemini',
    image: popcornImg,
    title: 'Popcorn',
    description:
        'Brain buzzing? A multitask snack for a multitask sign.',
  },
  {
    zodiac: '♋︎ Cancer',
    image: pbnjSandwichImg,
    title: 'PB&J Sandwich',
    description:
        'Jupiter retro in Cancer: comfort food keeps your mood steady.',
  },
  {
    zodiac: '♌︎ Leo',
    image: cheesePizzaImg,
    title: 'Cheese Pizza',
    description:
        'Venus in Leo wants spotlight snacks—cheesy, bold, shareable.',
  },
  {
    zodiac: '♍︎ Virgo',
    image: appleSlicesImg,
    title: 'Apple Slices',
    description:
        'Venus moves into your sign—fresh, crisp, and clean is your vibe.',
  },
  {
    zodiac: '♎︎ Libra',
    image: pretzelsImg,
    title: 'Pretzels',
    description:
        'Mercury in Libra: balance salty & soft for perfect harmony.',
  },
  {
    zodiac: '♏︎ Scorpio',
    image: darkChocolateImg,
    title: 'Dark Chocolate',
    description:
        'Retrogrades stir deep feels—indulge in a moody, rich bite.',
  },
  {
    zodiac: '♐︎ Sagittarius',
    image: trailMixImg,
    title: 'Trail Mix',
    description:
        'Energy high, direction unclear—grab a mix that goes anywhere.',
  },
  {
    zodiac: '♑︎ Capricorn',
    image: crackersnCheeseImg,
    title: 'Crackers & Cheese',
    description:
        'Saturn retro in Pisces: keep it classic, structured, dependable.',
  },
  {
    zodiac: '♒︎ Aquarius',
    image: popRocksImg,
    title: 'Pop Rocks',
    description:
        'Uranus retro shakes things up—snack with a spark of surprise.',
  },
  {
    zodiac: '♓︎ Pisces',
    image: iceCreamConeImg,
    title: 'Ice Cream Cone',
    description:
        'Neptune retro blurs lines—find dreamy escape in something cold & sweet.',
  },
];